import React from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function ReturnLabelModal({ isOpen, onConfirm, onClose }) {
  return (
    <Modal isOpen={isOpen} contentLabel="Add Note" className="confirm-modal">
      <div className="card">
        <button onClick={onClose} className="confirm-modal-close">
          <MdClose />
        </button>
        <div className="card-header">Return Label</div>
        <form>
          <div className="card-body">
            <div className="mb-3">
              Do you really want to sent return label link to Customer?
            </div>
          </div>
          <div className="card-footer">
            <button
              type="submit"
              className="btn btn-outline-primary mr-3"
              data-testid="modal-approve-btn"
              onClick={onConfirm}
            >
              Confirm
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
              data-testid="modal-approve-btn-cancel"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
